import { render, staticRenderFns } from "./AffinitySubmissionForm.vue?vue&type=template&id=67c08b4c&"
import script from "./AffinitySubmissionForm.vue?vue&type=script&lang=js&"
export * from "./AffinitySubmissionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports